<template>
  <div class="availability-card" :class="{ 'is-revealed': revealed, 'is-dragging': dragging, 'is-elevated':revealed||dragging||closing, unavailable:!enabled, 'has-gesture':manageable }" @keydown="keyDown" @pointerdown.capture="start" @pointermove.capture="move" @pointerup.capture="end" @pointercancel.capture="cancel"
    @touchstart="touchStart" @touchmove="touchMove" @touchend="touchEnd" @touchcancel="touchCancel" @click.capture="captureClick" @dragstart.prevent @contextmenu.prevent>
    <div v-if="manageable" ref="controls" class="availability-controls" :aria-hidden="!revealed" :inert="!revealed ? '' : null">
      <label><span>{{ enabled ? 'Activo' : 'Inactivo' }}</span><input type="checkbox" role="switch" :aria-label="'Disponibilidad de '+name" :checked="enabled" :disabled="busy || !revealed" :tabindex="revealed ? 0 : -1" @change="change" /></label>
    </div>
    <div ref="face" class="availability-face" :style="{ transform:'translate3d(0,'+offset+'px,0)' }" @transitionend.self="settled">
      <slot />
    </div>
  </div>
</template>
<script>
const REVEAL=48;
const THRESHOLD=10;
const HOLD_MS=280;
export default {
  props:{name:String,enabled:Boolean,busy:Boolean,linked:Boolean,pending:Boolean,manageable:{type:Boolean,default:true}},emits:['change'],
  data:()=>({offset:0,dragging:false,closing:false}),
  computed:{revealed(){return this.offset>0;}},
  created(){this.gesture=null;this.suppressClickUntil=0;this.closeTimer=null;this.holdTimer=null;},
  mounted(){
    document.addEventListener('pointerdown',this.outside,true);
    document.addEventListener('click',this.outside,true);
    document.addEventListener('focusin',this.outside,true);
    this.scrollContainer=this.$el.closest('.product-grid');
    this.scrollContainer?.addEventListener('scroll',this.scrolled,{passive:true});
  },
  beforeUnmount(){
    document.removeEventListener('pointerdown',this.outside,true);
    document.removeEventListener('click',this.outside,true);
    document.removeEventListener('focusin',this.outside,true);
    this.scrollContainer?.removeEventListener('scroll',this.scrolled);
    clearTimeout(this.closeTimer);this.release();
  },
  methods:{
    change(e){const value=e.target.checked;e.target.checked=this.enabled;this.$emit('change',value);},
    outside(e){if(this.revealed&&!this.$el.contains(e.target))this.close();},
    scrolled(){if(this.revealed||this.gesture)this.close();},
    close(){
      if(this.$refs.controls?.contains(document.activeElement))document.activeElement.blur();
      this.settle(0);this.release();
    },
    settle(target){
      clearTimeout(this.closeTimer);this.closing=target===0&&this.offset>0;this.offset=target;
      if(this.closing)this.closeTimer=setTimeout(()=>{this.closing=false;},280);
    },
    settled(e){if(e.propertyName==='transform'&&this.offset===0){clearTimeout(this.closeTimer);this.closing=false;}},
    keyDown(e){
      if(!this.manageable)return;
      if(e.key==='Escape'||e.altKey&&e.key==='ArrowUp'){e.preventDefault();this.close();}
      else if(e.altKey&&e.key==='ArrowDown'){e.preventDefault();this.settle(REVEAL);}
    },
    start(e){
      if(e.pointerType==='touch'||!this.manageable||!e.isPrimary||e.button!==0)return;
      this.suppressClickUntil=0;
      if(this.$refs.controls?.contains(e.target)&&e.target.closest('input'))return;
      // The product's ordinary button keeps its tap; small secondary buttons keep theirs too.
      if(e.target.closest('button,a,input,select,textarea')&&!e.target.closest('.product-tile')){this.close();return;}
      this.gesture={source:'pointer',id:e.pointerId,x:e.clientX,y:e.clientY,offset:this.offset};
    },
    move(e){
      const g=this.gesture;if(g?.source!=='pointer'||g.id!==e.pointerId)return;
      const dx=e.clientX-g.x,dy=e.clientY-g.y;
      if(!this.dragging){
        if(Math.max(Math.abs(dx),Math.abs(dy))<THRESHOLD)return;
        if(Math.abs(dx)>Math.abs(dy)){this.release();return;}
        this.dragging=true;
        this.$el.setPointerCapture?.(e.pointerId);
      }
      if(e.cancelable)e.preventDefault();
      this.offset=Math.min(REVEAL,Math.max(0,g.offset+dy*.9));
    },
    end(e){
      if(this.gesture?.source!=='pointer'||this.gesture.id!==e.pointerId)return;
      const dragged=this.dragging;
      if(dragged){this.settle(this.offset>=REVEAL/2?REVEAL:0);this.suppressClickUntil=Date.now()+500;}
      this.release();
    },
    cancel(e){
      if(this.gesture?.source!=='pointer'||e.pointerId!==this.gesture.id)return;
      this.settle(this.gesture.offset>=REVEAL/2?REVEAL:0);
      if(this.dragging)this.suppressClickUntil=Date.now()+500;
      this.release();
    },
    release(){
      clearTimeout(this.holdTimer);this.holdTimer=null;
      const id=this.gesture?.source==='pointer'?this.gesture.id:undefined;this.gesture=null;this.dragging=false;
      if(id!==undefined&&this.$el?.hasPointerCapture?.(id))this.$el.releasePointerCapture(id);
    },
    captureClick(e){
      if(Date.now()<this.suppressClickUntil){e.preventDefault();e.stopPropagation();return;}
      if(this.revealed&&this.$refs.face.contains(e.target))this.close();
    },
    touchStart(e){
      if(e.touches.length!==1){this.touchCancel();return;}
      this.suppressClickUntil=0;
      if(!this.manageable||this.$refs.controls?.contains(e.target))return;
      if(e.target.closest('button,a,input,select,textarea')&&!e.target.closest('.product-tile')){this.close();return;}
      const t=e.touches[0];
      const g={source:'touch',id:t.identifier,x:t.clientX,y:t.clientY,offset:this.offset,armed:false};
      this.release();this.gesture=g;
      // A normal swipe always belongs to the catalog. Only a stationary hold
      // claims the following drag, before the browser starts native scrolling.
      this.holdTimer=setTimeout(()=>{if(this.gesture===g)g.armed=true;},HOLD_MS);
    },
    touchMove(e){
      const g=this.gesture;if(g?.source!=='touch')return;
      if(e.touches.length!==1){this.touchCancel();return;}
      const t=Array.from(e.touches).find(t=>t.identifier===g.id);if(!t)return;
      const dx=t.clientX-g.x,dy=t.clientY-g.y;
      if(!g.armed){
        if(Math.max(Math.abs(dx),Math.abs(dy))>=THRESHOLD)this.close();
        return;
      }
      // Once native panning owns a gesture it cannot be reclaimed mid-swipe.
      if(!e.cancelable){this.close();return;}
      e.preventDefault();
      if(Math.abs(dy)>=THRESHOLD)this.dragging=true;
      if(this.dragging)this.offset=Math.min(REVEAL,Math.max(0,g.offset+dy*.9));
    },
    touchEnd(e){
      const g=this.gesture;if(g?.source!=='touch')return;
      if(!Array.from(e.changedTouches).some(t=>t.identifier===g.id))return;
      if(g.armed){
        if(e.cancelable)e.preventDefault();
        this.suppressClickUntil=Date.now()+500;
        this.settle(this.offset>=REVEAL/2?REVEAL:0);
      }
      this.release();
    },
    touchCancel(){
      if(this.gesture?.source!=='touch')return;
      this.settle(this.gesture.offset>=REVEAL/2?REVEAL:0);
      if(this.gesture.armed)this.suppressClickUntil=Date.now()+500;
      this.release();
    }
  }
};
</script>
<style scoped>
.availability-card{position:relative;min-width:0;min-height:var(--pos-tile-height,120px);border-radius:22px;z-index:0;align-self:stretch;touch-action:pan-y pinch-zoom}
.availability-card.is-elevated{z-index:20}
.has-gesture{-webkit-user-select:none;user-select:none;-webkit-touch-callout:none}
.availability-controls{position:absolute;inset:0 0 auto;height:48px;padding:2px 12px;border-radius:22px 22px 0 0;background:#e8eee9;color:#344b40;opacity:0;pointer-events:none;transition:opacity .16s ease}
.is-revealed .availability-controls{opacity:1;pointer-events:auto}
.availability-controls label{display:flex;height:44px;justify-content:space-between;align-items:center;gap:8px;font-size:.8rem;font-weight:800}
.availability-controls input{appearance:none;width:42px;height:24px;margin:0;background:#a4aaa8;border:0;border-radius:20px;position:relative;cursor:pointer;flex:0 0 42px}
.availability-controls input::before{content:'';position:absolute;width:18px;height:18px;left:3px;top:3px;border-radius:50%;background:white;transition:transform .16s}
.availability-controls input:checked{background:#48734d}.availability-controls input:checked::before{transform:translateX(18px)}
.availability-controls input:disabled{opacity:.45}.availability-controls input:focus-visible{outline:3px solid #285f47;outline-offset:3px}
.availability-face{position:relative;display:grid;min-height:inherit;height:100%;border-radius:inherit;background:var(--pos-tile-color,#edf2f7);box-shadow:0 5px 13px rgba(29,53,87,.05);transition:transform .24s cubic-bezier(.2,.85,.25,1),box-shadow .24s ease}
.is-elevated .availability-face{box-shadow:0 19px 30px -8px rgba(20,36,48,.32),0 7px 12px -5px rgba(20,36,48,.2)}
.is-dragging .availability-face{transition:none;will-change:transform}
.availability-face :deep(.product-tile-wrap){min-height:inherit;height:100%}
.availability-face :deep(.product-tile){min-height:inherit;height:100%;margin:0}
.availability-face :deep(.product-tile:hover){transform:none}
.availability-face :deep(.product-tile:disabled){pointer-events:none}
.unavailable .availability-face{filter:saturate(.45)}
@media(prefers-reduced-motion:reduce){.availability-face,.availability-controls,.availability-controls input::before{transition:none}}
</style>
